import { useGetComponentStringsContext } from "../../hooks/useGetComponentStrings";

export const AccessDeniedPage: React.FC = () => {
	const sharedStrings = useGetComponentStringsContext().Shared;

	return <div>{sharedStrings.accessDeniedMessage}</div>;
};
